import { gql } from "@apollo/client";

export const CREATE_FRECUENCIA_DISTRIBUIDOR = gql`
    mutation createFrecuenciaDistribuidor(
        $idProveedorDistribuidor: Int!,
        $kilometroDestino: Int!,
        $costoEntregaInmediata: Decimal!,
        $idDeposito: Int!,
        $activo: Boolean!,
        $idFrecuenciaModoDespacho: Int!,
        $listaFrecuenciaDistribuidorDetalles: [AddFrecuenciaDistribuidorDetalleInput!]!,
        $listaFrecuenciaDistribuidorCPs: [AddFrecuenciaDistribuidorCPInput!]!
    ){
        createFrecuenciaDistribuidor(
            input: {
                idProveedorDistribuidor: $idProveedorDistribuidor,
                kilometroDestino: $kilometroDestino,
                costoEntregaInmediata: $costoEntregaInmediata,
                idDeposito: $idDeposito,
                activo: $activo,
                idFrecuenciaModoDespacho: $idFrecuenciaModoDespacho,
                listaFrecuenciaDistribuidorDetalles: $listaFrecuenciaDistribuidorDetalles,
                listaFrecuenciaDistribuidorCPs: $listaFrecuenciaDistribuidorCPs
            }
        ) {
            idFrecuenciaDistribuidor
          }
    }
`;